/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { ProcedureCategory } from '../../procedure/SubmissionProcedure';
import useProcedures from '../../procedure/useProcedures';

/*
 * Generic hook to handle information about subsequent actions for a specific procedure
 * returns:
 *  - enabled: checks if subsequent actions are enabled for a specific procedure
 *  - resource: return subsequent actions procedure from configuration
 *      - only if the specific procedure has SA enabled, otherwise return undefined
 *      - only if the specific procedure has SA enabled, otherwise return undefined
 */
export function useSubsequentActions(procedureId) {
  const { procedures = {}, getProcedure } = useProcedures();

  const initialProcedure = getProcedure(procedureId);
  const enabled = !!initialProcedure?.subsequentActions?.enabled;
  const subsequentActionName = initialProcedure?.subsequentActions?.subsequentActionName;

  let resource;
  if (enabled) {
    resource = subsequentActionName
      ? Object.values(procedures).find(({ id }) => id === subsequentActionName)
      : Object.values(procedures).find(({ category }) => category === ProcedureCategory.SUBSEQUENT_ACTIONS);
  }

  return {
    enabled,
    resource,
    initialProcedure,
  };
}
